import { createSelector } from '@ngrx/store';
import { selectDecoratorsState } from './decorators.selector';

export const getBaseHrefForLinkPlugin = createSelector(
  selectDecoratorsState,
  (state): string => state?.baseHrefForLinkPlugin
);

export const getBaseHrefPathUrl = createSelector(
  selectDecoratorsState,
  (state): string => state?.baseHrefPathUrl
);

export const getBaseHrefId = createSelector(
  selectDecoratorsState,
  (state): string => state?.baseHrefId
);
